export default "__VITE_ASSET__c60deea1__"